export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CN-0310e291e7caba24f8b506ae60061453.png";